import * as Immutable from "immutable";
import { Panel } from "./panel";
import { PropertyControl } from "./propertyControl";

export class PropertyPanel extends Panel {

  protected readonly Items = "items";

  get items(): Immutable.List<PropertyControl> { return this.getInternalValue<Immutable.List<PropertyControl>>(this.Items); }
  setItems(items: Immutable.List<PropertyControl>): this { return this.setInternalValue(this.Items, items); }
}